import { TechemTheme } from '@techem/techem-theme';
import { StyletronEngineProvider, ThemeContextProvider } from '@techem/ui-components';
import { BaseProvider } from 'baseui';
import DefaultLayout from 'frameworks_drivers/layout/DefaultLayout';
import React, { useEffect, useState } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Provider as ReduxProvider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import {
  setDiscountCodeNeedsValidation,
  setReferralDiscountCode
} from 'frameworks_drivers/redux/reducers/miscellaneous/miscSlice';
import Routes from 'frameworks_drivers/routes/ApplicationRoutes';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { loadAdobeAnalytics } from 'tracking/adobe';
import './App.scss';
import { ABTestingKeys } from './frameworks_drivers/redux/reducers/abTest/abTesting';
import store from './store';
import storage from './tools/localstorage/localStorage';
import TrackingService from './tracking/TrackingService';

const styletronEngine = new Styletron({
  // ensure compatibility with other frameworks like bootstrap by prefixing class names, etc.
  prefix: 'st-'
});

function resolveLandingPageScenario(altHome: string | null = 'false') {
  return altHome === 'true' ? 'scenario_b' : 'default'; // We have to set a default scenario in case that the
  // parameter alt_home is not set
}

const App = () => {
  const [initDone, setInitDone] = useState<boolean>(false);

  useEffect(() => {
    const initializeGlobal = async () => {
      try {
        const { loadTrackingScripts, setupTracking, trackPage } = TrackingService();

        setupTracking();

        await loadAdobeAnalytics();
        await loadTrackingScripts();

        trackPage();
      } catch (err) {
        console.error('Client side global js init failed', err);
      } finally {
        setInitDone(true);
      }
    };

    // Locally store promotion code if available
    // to incorporate it in pricing mechanism later on.
    const queryParams = new URLSearchParams(window.location.search);
    const promotionCode = queryParams.get('pcode');

    // Save the landingpage scenario into local storage to process it easier to adobe analytics
    const landingPageScenario = queryParams.get('alt_home');
    storage.setABTestingValue(
      ABTestingKeys.LandingPage,
      resolveLandingPageScenario(landingPageScenario as string)
    );

    if (promotionCode && promotionCode !== '') {
      store.dispatch(setReferralDiscountCode(promotionCode));
      // Ensure we fire a discount API request automatically once the offerpage appears.
      store.dispatch(setDiscountCodeNeedsValidation(true));
    }

    initializeGlobal();
  }, []);

  return initDone ? (
    <ReduxProvider store={store}>
      <ThemeContextProvider value={TechemTheme}>
        <BaseProvider theme={TechemTheme}>
          <StyletronProvider value={styletronEngine}>
            <StyletronEngineProvider value={styletronEngine}>
              <HashRouter>
                <DefaultLayout>
                  <Routes />
                </DefaultLayout>
              </HashRouter>
            </StyletronEngineProvider>
          </StyletronProvider>
        </BaseProvider>
      </ThemeContextProvider>
    </ReduxProvider>
  ) : null;
};
export default App;
